module.exports = __webpack_public_path__ + "static/media/sl.f26d261f.svg";